import { Box, Button } from "@mui/material";
import styles from './styles.module.scss';
import clsx from 'clsx';

const TraceTab = (props) => {
    const { traceUrl } = props;

    const handleInspectClick = () => {
        const viewerUrl = `https://trace.playwright.dev/?trace=${encodeURIComponent(traceUrl)}`;
        window.open(viewerUrl, '_blank');
    };

    if (!traceUrl) return (
        <Box className={styles.traceTabContainer}>
            <span className={styles.traceEmpty}>
                No trace files are available for this step.
            </span>
        </Box>
    );
    return (
        <Box className={styles.traceTabContainer}>
            <Box className={styles.traceButtonContainer}>
                <Button
                    variant="contained"
                    color="secondary"
                    className={styles.traceButton}
                    href={traceUrl}
                >
                    Download trace file
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    className={clsx(styles.traceButton, styles.traceButtonRigth)}
                    onClick={handleInspectClick}
                >
                    Inspect trace file
                </Button>
            </Box>
        </Box>
    );
}

export default TraceTab;
